import { SubmitFilterDataType } from "@saleor/changeOrderExport/components/OrderFilterSection/constant";
import { ViewEditMode } from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import {
  DomesticOrderConfirmationFilterInput,
  SapListOfSaleOrderInput
} from "@saleor/graphql";

export interface AppError {
  type: "unhandled";
  id: string | null | undefined;
}

interface IAppState {
  error: AppError | null;
  loading: boolean;
  expandMenu?: boolean;
  fullScreen?: boolean;
  customerId?: string;
  orderCount?: number;
  bodyPaddingRight?: number;
  tabMaterial?: number;
  viewEditMode?: ViewEditMode;
  filterOrder?: SubmitFilterDataType;
  filterOrderConfirm?: DomesticOrderConfirmationFilterInput;
  filterListSalesOrder: SapListOfSaleOrderInput;
  snackbarAlterMaterial?: boolean;
  snackbarEditAlterMaterial?: boolean;
  snackbarMsg?: string;
  showPoUpload?: boolean;
  searchIdExport?: string;
  tabSoldToExport?: number;
}

export const initialAppState: IAppState = {
  error: null,
  loading: false,
  expandMenu: true,
  fullScreen: false,
  customerId: "",
  orderCount: 0,
  bodyPaddingRight: 0,
  tabMaterial: 0,
  viewEditMode: ViewEditMode.VIEW,
  filterOrder: null,
  filterOrderConfirm: null,
  filterListSalesOrder: null,
  snackbarAlterMaterial: false,
  snackbarEditAlterMaterial: false,
  snackbarMsg: "",
  showPoUpload: false,
  searchIdExport: "",
  tabSoldToExport: 2
};

export default IAppState;
